// Add blobs animations
// Copied from kros.sk
import { debounce } from '@webikon/webentor-core/_utils';

const imageSources = [
  'https://web.kros.sk/wp-content/uploads/2025/03/Group-311.svg',
  'https://web.kros.sk/wp-content/uploads/2025/03/Group-310.svg',
  'https://web.kros.sk/wp-content/uploads/2025/01/clouds-bg.svg',
];

function cleanupBlobs() {
  document
    .querySelectorAll('.floating-cloud')
    .forEach((cloud) => cloud.remove());
}

function initializeBlob(section: Element) {
  if (section.classList.contains('no-cloud')) return;

  const cloud = document.createElement('img');
  cloud.classList.add('floating-cloud');
  cloud.src = imageSources[Math.floor(Math.random() * imageSources.length)];

  // Generate random size between 500px and 1200px
  const size = Math.floor(Math.random() * (1200 - 500 + 1)) + 500;
  cloud.style.width = `${size}px`;
  cloud.style.height = 'auto';
  cloud.style.position = 'absolute';

  // Position cloud randomly within section
  const sectionRect = section.getBoundingClientRect();
  const randomX = Math.random() * (sectionRect.width - size);
  const randomY = Math.random() * (sectionRect.height - size);
  cloud.style.left = `${randomX}px`;
  cloud.style.top = `${randomY}px`;

  section.appendChild(cloud);

  cloud.onload = function () {
    cloud.style.transform = 'translate(0, 0) rotate(0deg)';
    cloud.style.transition = 'transform 6s ease-in-out, rotate 6s ease-in-out';

    function repeatAnimation() {
      cloud.style.transform = `translate(${Math.random() * 1200 - 600}px, ${Math.random() * 1200 - 600}px) rotate(360deg)`;
      setTimeout(() => {
        cloud.style.transform = 'translate(0, 0) rotate(0deg)';
      }, 6000);
    }

    repeatAnimation();
    setInterval(repeatAnimation, 12000);
  };
}

function initializeBlobs() {
  cleanupBlobs();
  document
    .querySelectorAll('.w-section:nth-child(2n), .hero, .toc-section')
    .forEach(initializeBlob);
}

document.addEventListener('DOMContentLoaded', () => {
  initializeBlobs();
  window.addEventListener('resize', debounce(initializeBlobs, 250));
});
